import { Children } from 'react';
import styles from './list-with-dots.module.scss';

export type ListWithDotsProps = {
  items?: React.ReactNode[];
  children?: React.ReactNode;
};

/**
 * Set list of elements
 * @param items
 */
export const ListWithDots = ({ items, children }: ListWithDotsProps) => {
  return (
    <ul className={styles.list}>
      {items?.map((item, index) => (
        <li key={index} className={styles.listItem}>
          {item}
        </li>
      ))}

      {Children.map(children, (child, index) => (
        <li key={`child-${index}`} className={styles.listItem}>
          {child}
        </li>
      ))}
    </ul>
  );
};
